(function () {
  'use strict';

  var VAT_RATE = 0.20;
  var MONEY_SYMBOL = '£';
  var MONEY_LOCALE = 'en-GB';
  var VAT_LABEL = 'VAT (20%)';

  function applyConfigMeta(config) {
    if (!config) return;
    if (typeof config.vatRate === 'number') VAT_RATE = config.vatRate;
    if (config.moneySymbol) MONEY_SYMBOL = config.moneySymbol;
    if (config.moneyLocale) MONEY_LOCALE = config.moneyLocale;
    if (config.vatLabel) VAT_LABEL = config.vatLabel;
  }

  function formatMoney(minorUnits, decimals) {
    var d = decimals === undefined ? 0 : decimals;
    return MONEY_SYMBOL + (minorUnits / 100).toLocaleString(MONEY_LOCALE, {
      minimumFractionDigits: d,
      maximumFractionDigits: d
    });
  }

  function getConfig() {
    var el = document.getElementById('eride-pricing-config');
    if (!el) return null;
    try {
      var config = JSON.parse(el.textContent);
      applyConfigMeta(config);
      return config;
    } catch (e) {
      return null;
    }
  }

  function getModel(config) {
    if (!config || !config.models) return null;
    return config.models[config.productHandle] || null;
  }

  function getMinQty(model) {
    if (!model) return 1;
    return model.minQty > 0 ? model.minQty : 1;
  }

  function getDealerExVat(model) {
    if (!model) return 0;
    return model.dealerExVat || model.tier1ExVat || model.tier2ExVat || 0;
  }

  function incVat(exMinor) {
    return Math.round(exMinor * (1 + VAT_RATE));
  }

  function syncThemePrice(exUnitMinor) {
    var priceEl = document.getElementById('ProductPrice');
    if (!priceEl) return;
    var display = formatMoney(incVat(exUnitMinor));
    var inner = priceEl.querySelector('[ymq-b2b-variant-price]') || priceEl.querySelector('span') || priceEl;
    inner.textContent = display;
  }

  function hideNativePrice() {
    var widget = document.getElementById('eride-tier-widget');
    if (!widget) return;
    document.body.classList.add('eride-has-tier-pricing');
    var priceBlock = document.querySelector('.product-details-price');
    if (priceBlock) priceBlock.style.display = 'none';
    var priceLabel = document.querySelector('.price-label');
    if (priceLabel) priceLabel.style.display = 'none';
  }

  function updateVatLabel(widget) {
    var vatLabelEl = widget.querySelector('[data-vat-label]');
    if (vatLabelEl) vatLabelEl.textContent = VAT_LABEL;
  }

  function initTierWidget() {
    var widget = document.querySelector('[data-eride-tier]');
    if (!widget) return;

    var config = getConfig();
    if (!config || config.tradeAccess !== true) {
      return;
    }

    var model = getModel(config);
    if (!model || !getDealerExVat(model)) {
      widget.style.display = 'none';
      return;
    }

    hideNativePrice();
    updateVatLabel(widget);

    var qtyInput = widget.querySelector('.eride-pricing__qty-input');
    var cartQtyInput = document.querySelector('.cart-plus-minus-box[name="quantity"]');
    var formQtyInput = document.querySelector('[data-eride-form-qty]');
    var tierProperty = widget.querySelector('[data-tier-property]');
    var unitPriceProperty = widget.querySelector('[data-unit-price-property]');
    var minQtyProperty = widget.querySelector('[data-min-qty-property]');
    var minQty = getMinQty(model);
    var minusBtn = widget.querySelector('[data-qty-minus]');
    var plusBtn = widget.querySelector('[data-qty-plus]');

    if (!qtyInput) {
      render();
      return;
    }

    if (qtyInput) {
      qtyInput.min = minQty;
      if ((parseInt(qtyInput.value, 10) || minQty) < minQty) {
        qtyInput.value = minQty;
      }
    }

    function render() {
      var qty = Math.max(minQty, parseInt(qtyInput.value, 10) || minQty);
      if (parseInt(qtyInput.value, 10) !== qty) qtyInput.value = qty;
      var unitEx = getDealerExVat(model);
      var subtotalEx = unitEx * qty;
      var vatAmount = Math.round(subtotalEx * VAT_RATE);
      var orderTotal = subtotalEx + vatAmount;

      var heroEx = widget.querySelector('[data-hero-ex]');
      var heroInc = widget.querySelector('[data-hero-inc]');
      if (heroEx) heroEx.textContent = formatMoney(unitEx) + ' ex. VAT';
      if (heroInc) heroInc.textContent = formatMoney(incVat(unitEx)) + ' inc. VAT per unit';

      var breakdownQty = widget.querySelector('[data-breakdown-qty]');
      var breakdownSub = widget.querySelector('[data-breakdown-subtotal]');
      var breakdownVat = widget.querySelector('[data-breakdown-vat]');
      var breakdownTotal = widget.querySelector('[data-breakdown-total]');

      if (breakdownQty) breakdownQty.textContent = qty + ' unit' + (qty > 1 ? 's' : '');
      if (breakdownSub) breakdownSub.textContent = formatMoney(subtotalEx, 2) + ' ex. VAT';
      if (breakdownVat) breakdownVat.textContent = formatMoney(vatAmount, 2);
      if (breakdownTotal) breakdownTotal.textContent = formatMoney(orderTotal, 2) + ' inc. VAT';

      if (cartQtyInput) cartQtyInput.value = qty;
      if (formQtyInput) formQtyInput.value = qty;
      if (tierProperty) tierProperty.value = 'dealer';
      if (unitPriceProperty) unitPriceProperty.value = (unitEx / 100).toFixed(2);
      if (minQtyProperty) minQtyProperty.value = String(minQty);

      syncThemePrice(unitEx);

      document.dispatchEvent(new CustomEvent('eride:tier-change', {
        detail: { qty: qty, unitEx: unitEx, total: orderTotal }
      }));
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(minQty, (parseInt(qtyInput.value, 10) || minQty) - 1);
        render();
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || minQty) + 1);
        render();
      });
    }

    qtyInput.addEventListener('input', render);
    qtyInput.addEventListener('change', render);

    if (cartQtyInput) {
      cartQtyInput.addEventListener('change', function () {
        qtyInput.value = cartQtyInput.value;
        render();
      });
    }

    document.addEventListener('eride:pre-add-to-cart', render);

    render();
  }

  function initShippingCalculator() {
    var calc = document.querySelector('[data-eride-shipping]');
    if (!calc || document.getElementById('eride-tier-widget')) return;

    var config = getConfig();
    if (!config || !config.shipping) return;

    var regionSelect = calc.querySelector('[data-ship-region]');
    var qtyInput = calc.querySelector('[data-ship-qty]');
    var resultPrice = calc.querySelector('[data-ship-price]');
    var resultDetail = calc.querySelector('[data-ship-detail]');
    var palletSlots = calc.querySelectorAll('[data-pallet-slot]');

    function render() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var ship = { pallets: 1, total: 0, region: null };
      if (config.shipping && config.shipping.regions) {
        var region = config.shipping.regions.find(function (r) { return r.id === regionSelect.value; });
        if (!region) region = config.shipping.regions[0];
        var pallets = Math.ceil(qty / config.shipping.bikesPerPallet);
        ship = { pallets: pallets, total: pallets * region.rate, region: region };
      }

      if (resultPrice) resultPrice.textContent = formatMoney(ship.total, 2);
      if (resultDetail && ship.region) {
        resultDetail.textContent = ship.pallets + ' pallet' + (ship.pallets > 1 ? 's' : '') +
          ' × ' + formatMoney(ship.region.rate, 2) + ' · ' + ship.region.label;
      }

      palletSlots.forEach(function (slot, i) {
        if (qty > config.shipping.bikesPerPallet) {
          slot.classList.add('is-filled');
        } else {
          slot.classList.toggle('is-filled', i < qty);
        }
      });
    }

    if (regionSelect) regionSelect.addEventListener('change', render);
    if (qtyInput) qtyInput.addEventListener('input', render);

    document.addEventListener('eride:tier-change', function (e) {
      if (e.detail && qtyInput) {
        qtyInput.value = e.detail.qty;
        render();
      }
    });

    render();
  }

  function hookStandardAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#AddToCart');
      if (!btn) return;
      syncTierQtyToForm();
    }, true);

    var form = document.getElementById('AddToCartForm');
    if (!form || form.dataset.erideQtyHooked) return;
    form.dataset.erideQtyHooked = 'true';
    form.addEventListener('submit', syncTierQtyToForm, true);
  }

  function syncTierQtyToForm() {
    var widget = document.getElementById('eride-tier-widget');
    if (!widget) return;
    document.dispatchEvent(new CustomEvent('eride:pre-add-to-cart'));
    var config = getConfig();
    var model = getModel(config);
    if (!model) return;
    var minQty = getMinQty(model);
    var qtyInput = widget.querySelector('.eride-pricing__qty-input');
    var form = document.getElementById('AddToCartForm');
    if (!form) return;
    var formQty = form.querySelector('[data-eride-form-qty]') || form.querySelector('[name="quantity"]');
    var cartQty = form.querySelector('.cart-plus-minus-box[name="quantity"]');
    var qty = Math.max(minQty, parseInt(qtyInput && qtyInput.value, 10) || minQty);
    if (formQty) formQty.value = qty;
    if (cartQty) cartQty.value = qty;
  }

  function applyGridDealerPrices() {
    document.querySelectorAll('[data-eride-grid-price-ex]').forEach(function (el) {
      var exMinor = parseInt(el.getAttribute('data-eride-grid-price-ex'), 10);
      if (!exMinor) return;
      el.textContent = formatMoney(exMinor);
    });
  }

  function initCollectionDealerPrices() {
    if (!document.querySelector('[data-eride-grid-price-ex]')) return;

    applyGridDealerPrices();

    if (typeof MutationObserver === 'undefined') {
      window.setTimeout(applyGridDealerPrices, 1500);
      return;
    }

    var scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        applyGridDealerPrices();
      });
    }

    document.querySelectorAll('.ht-product-price').forEach(function (node) {
      new MutationObserver(scheduleApply).observe(node, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });

    [500, 1500, 3500].forEach(function (delay) {
      window.setTimeout(applyGridDealerPrices, delay);
    });
  }

  function initDealerGridActions() {
    if (!document.querySelector('.eride-dealer-grid-bar')) return;

    var compareBtnHtml = '<i class="sli sli-refresh"></i>';

    function restoreCompareButton(btn) {
      if (!btn) return;
      if (btn.querySelector('.sli-refresh')) return;
      btn.innerHTML = compareBtnHtml;
    }

    function restoreAllCompareButtons() {
      document.querySelectorAll('.eride-dealer-grid-bar .compare').forEach(restoreCompareButton);
    }

    restoreAllCompareButtons();
    window.setTimeout(restoreAllCompareButtons, 400);
    window.setTimeout(restoreAllCompareButtons, 1200);

    document.addEventListener('click', function (e) {
      var compareBtn = e.target.closest('.eride-dealer-grid-bar .compare');
      if (!compareBtn) return;
      window.setTimeout(function () { restoreCompareButton(compareBtn); }, 0);
      window.setTimeout(function () { restoreCompareButton(compareBtn); }, 120);
      window.setTimeout(function () { restoreCompareButton(compareBtn); }, 400);
    }, true);
  }

  function boot() {
    initTierWidget();
    initShippingCalculator();
    hookStandardAddToCart();
    initCollectionDealerPrices();
    initDealerGridActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
